module.exports = __webpack_public_path__ + "images/66eae09d360194d6cf09226cf7030a23-IMG_8827.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_8827.jpg
// module id = ./src/assets/images/slides/living2/IMG_8827.jpg
// module chunks = 0